import React from "react";
import { LinearProgress } from "@mui/material";

interface LoadingProps {
  show: boolean;
}

const Loading: React.FC<LoadingProps> = (props) => {
  const { show } = props;
  if (show) {
    return <LinearProgress color="secondary" />;
  }
  return null;
};
export default Loading;
